export default {
    ALCHEMICAL_TREATMENTS: 'Alchemical Treatments',

    CRAFTING_MATERIALS: 'Crafting Materials',

    HIDES_AND_ANIMAL_PARTS: 'Hides & Animal Parts',

    INGOTS_AND_MINERALS: 'Ingots & Minerals',
}